<template>
    <el-form ref="fieldForm" :model="field" :rules="rules" size="mini" label-position="top" class="field-props">
        <el-form-item label="字段类型">
            <el-input v-model="field.label" disabled ></el-input>
        </el-form-item>
        <el-form-item  v-if="!isShowDivider && !isShowSubFormSummary" label="是否单列显示">
          <el-radio-group v-model="field.options.unique" size="mini">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="字段名称" prop="name"
            :rules="[
                { min: 0, max: 100, message: '长度在100个字符内', trigger: 'blur' }
            ]">
            <el-input v-model="field.name" size="mini" placeholder="请输入字段名称,长度50字以内" show-word-limit maxlength="50"></el-input>
        </el-form-item>
        <el-form-item v-if="!isShowDivider" label="字段说明">
          <el-tooltip  content="请输入字段填写说明,长度500字以内，假如想隐藏当前字段，请输入$hideField$,数据安全显示用$dataSecurity$" effect="light" placement="top">
            <el-input type="textarea" :rows="4" v-model="field.options.description" size="mini" maxlength="500" show-word-limit placeholder="请输入字段填写说明,长度500字以内"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="字段类型"  v-if="isShowText || isShowNumber || isShowDate || isShowCategory || isShowSerialNumber || isShowUser || isShowDepartment || isShowDictionaryTree || isShowProcess || isShowFile || isShowCascader || isArchive">
            <el-radio-group v-model="field.options.config.type" size="mini" v-if="isShowText">
                <el-radio label="input">单行</el-radio>
                <el-radio label="textarea">多行</el-radio>
            </el-radio-group>
            <el-radio-group v-model="field.options.config.type" size="mini" v-if="isShowNumber">
                <el-radio label="number">数值</el-radio>
            </el-radio-group>

            <el-radio-group v-model="field.options.config.type" size="mini" v-else-if="isShowDate">
                <el-radio label="date">日期</el-radio>
                <el-radio label="dateTime">日期+时间</el-radio>
                <el-radio label="daterange">日期范围</el-radio>
            </el-radio-group>
           
            <el-radio-group v-model="field.options.config.type" size="mini" v-if="isShowBusinessTree || isShowCategory || isShowSerialNumber || isShowUser || isShowDepartment || isShowDictionaryTree || isShowCascader || isArchive">
                <el-radio label="single">单选</el-radio>
                <el-radio v-if="isShowSerialNumber" label="multi">单选(树)</el-radio>
                <el-radio v-else-if="isArchive" label="multi">
                    <el-tooltip  content="根据业务分类的类型带出对应的档案模板，选择模板后动态加载出对应的档案模板" effect="light" placement="top">
                      <span>按业务分类</span>
                    </el-tooltip>
                </el-radio>
                 <el-radio v-else label="multi">多选</el-radio>
            </el-radio-group>

            <el-radio-group v-model="field.options.config.type" size="mini" v-else-if="isShowFile">
                <el-radio label="file">普通文件</el-radio>
                <el-radio label="image">图片</el-radio>
            </el-radio-group>

            <el-radio-group v-model="field.options.config.type" size="mini" v-if="isShowProcess">
                <el-radio label="single">单选</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item v-if="field.type==='text'">
            <el-input placeholder="最大10000字" v-model="field.options.fieldMaxLength"  type="number">
                <template slot="prepend">字数限制</template>
            </el-input>
        </el-form-item>
        <el-form-item label="文本显示模式" v-if="isShowText && field.options.config.type === 'textarea'">
          <el-radio-group  v-model="field.options.ext3" size="mini">  
              <el-radio label="">多行文本</el-radio>
              <el-radio label="1">富文本框</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选项显示模式" v-if="isShowCategory&& field.options.config.type === 'single'">
          <el-radio-group  v-model="field.options.ext3" size="mini">
              <el-radio label="">按钮样式</el-radio>
              <el-radio label="1">单选框组</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备选项" v-if="isShowCategory || isShowSelect || isShowCascader">
            <div v-if="isShowCascader">
                <el-cascader
                    :options="field.options.config.options"
                    :props="{
                        label:'title',
                        expandTrigger: 'hover',
                        multiple: (field.options.config.type === 'multi')
                    }"
                    >
                </el-cascader>
                <el-button type="primary" icon="el-icon-edit" @click="handleEditCascader">编辑级联内容</el-button>
            </div>
            <FieldCategory v-else :categoryList="categoryList" :fieldType="fieldSubType" :field="field" :fieldsList="fieldsList" :relateModelList="relateModelList"/>
        </el-form-item>

        <FieldPropsLink :key="loadTimer" v-if="isShowLink" :field="field"  :channelFlag="channelFlag" :appId="appId" :allFields="fieldsList" ref="linkPropConfig" @initLimitData="initLimitData" @changeSelectTableHeaderFields="changeSelectTableHeaderFields"/>

          <!-- v-bind:selectedNode="selectedNode" -->
        <el-form-item label="业务分类数据源" v-if="isShowBusinessTree">
            <BusinessTree ref="treeChild"
                :selectedNode='selectedNode'
                :popover="true"
                :fieldType="fieldSubType"
                :channelFlag="channelFlag"
                :defaultClass="'business-tree-form'"
                :appId="appId"
                @nodeClick="handleTreeNode"
            />
        </el-form-item>

        <el-form-item label="流水号数据源" v-if="isShowSerialNumber">
            <!-- 多流水号数据源配置 -->
            <el-tooltip  content="勾选了此配置则流水号可以配置多个，然后根据表单的某个字段值进行动态匹配流水号规则" effect="light" placement="top">
              <el-checkbox v-model="field.options.moreSerialNumber" label="是否多规则" name="type" @change="renderSerialNumberVal"></el-checkbox>
            </el-tooltip>
            <!-- 单规则 -->
            <template v-if="!field.options.moreSerialNumber">
                <SerialNumber ref="treeChild"
                    :selectedNode='selectedNode'
                    :popover="true"
                    :fieldType="fieldSubType"
                    :channelFlag="channelFlag"
                    :defaultClass="'serialnumber-tree-form'"
                    :appId="appId"
                    @nodeClick="handleTreeNode"
                />
                <!-- 部门字段 -->
                <div class="option-data-field" v-if="isShowSeriaConfig">
                <el-select v-model="field.options.seriaNumberFormFieldId" placeholder="请选择表单的部门字段" clearable>
                    <template  v-for="item in formLevelFieldList" >
                            <el-option
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-if="item.type === 'department'"
                            >
                        </el-option>
                    </template>
                    </el-select>
                </div>
                <!-- 下拉字段 -->
                <div class="option-data-field" v-if="isShowSeriaSelectFieldConfig">
                    <el-select v-model="field.options.seriaNumberSelectTypeFormFieldId" placeholder="请选择表单的下拉字段" clearable>
                        <template  v-for="item in formLevelFieldList" >
                                <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-if="obj.type === 'select' || (obj.type === 'category' && obj.options.config.type==='single')"
                                >
                            </el-option>
                        </template>
                    </el-select>
                </div>
                <!-- 业务分类树 -->
                <div class="option-data-field" v-if="isShowSeriaBusinessTypeConfig">
                    请选择业务分类字段:
                    <el-select v-model="field.options.seriaNumberBusinessTypeFormFieldId" placeholder="请选择表单的业务分类字段" clearable>
                        <template v-for="item in formLevelFieldList" >
                            <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-if="item.type === 'businessTree'"
                                >
                                </el-option>
                        </template>
                    </el-select>
                    <el-select v-model="field.options.seriaNumberBusinessTypeFormFieldIdValue" placeholder="请选择取值字段" v-if="field.options.seriaNumberBusinessTypeFormFieldId" clearable>
                        <el-option key="1" label="节点名称" value="1"></el-option>
                        <el-option key="2" label="节点描述" value="2"></el-option>
                    </el-select>
                </div>
                <!-- 部门 -->
                <div class="option-data-field" v-if="isShowSeriaDepartTypeConfig">
                    请选择业务部门字段:
                    <el-select v-model="field.options.seriaNumberDepartTypeFormFieldId" placeholder="请选择表单的关联字段" clearable>
                        <template v-for="item in formLevelFieldList">
                            <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-if="item.type == 'department'"
                                >
                            </el-option>
                        </template>
                    </el-select>
                    <el-select v-model="field.options.seriaNumberDepartTypeFormFieldIdValue" placeholder="请选择取值字段" v-if="field.options.seriaNumberDepartTypeFormFieldId" clearable>
                        <el-option key="1" label="部门名称" value="1"></el-option>
                        <el-option key="2" label="部门简称" value="2"></el-option>
                        <el-option key="3" label="流水号标识" value="3"></el-option>
                        <el-option key="4" label="备注" value="4"></el-option>
                    </el-select>
                </div>
          </template>
          <!-- 多规则 -->
            <div :key="timeMoreSerialNumber" v-if="field.options.moreSerialNumber" class="serialNumberBox">
                流水号规则:
                <div v-for="(item,index) in field.options.serialNumberRuleList" :key="index" class="serialNumberBoxItem">
                    <div class="serialNumberBoxItemLabel">
                        规则{{ index+1 }} <el-tag type="danger" @click="deleteSeriRul(field.options.serialNumberRuleList,index)" style="cursor: pointer;">删除</el-tag>
                    </div>
                    <div class="serialNumberBoxItemTree">
                        选取流水号规则:
                        <SerialNumber ref="treeChild"
                            :selectedNode='item.selectedNode'
                            :popover="true"
                            :fieldType="fieldSubType"
                            :channelFlag="channelFlag"
                            :defaultClass="'serialnumber-tree-form'"
                            :appId="appId"
                            :callBackData="item"
                            @nodeClick="handleSerialNumber"
                        />
                    </div>
                    <!-- 下拉字段 -->
                    流水号下拉字段匹配:
                    <div class="option-data-field" v-if="item.isShowSeriaSelectFieldConfig">
                        <el-select v-model="item.seriaNumberSelectTypeFormFieldId" placeholder="请选择表单的下拉字段" clearable @change="renderFieldList">
                            <template  v-for="obj in formLevelFieldList" >
                                <el-option
                                :key="obj.id"
                                :label="obj.name"
                                :value="obj.id"
                                v-if="obj.type === 'select' || (obj.type === 'category' && obj.options.config.type==='single')"
                                >
                                </el-option>
                            </template>
                        </el-select>
                    </div>
                    <!-- 部门 -->
                    <div class="option-data-field" v-if="item.isShowSeriaDepartTypeConfig">
                        请选择业务部门字段:
                        <el-select v-model="item.seriaNumberDepartTypeFormFieldId" placeholder="请选择表单的关联字段" clearable @change="renderFieldList">
                            <template v-for="obj in formLevelFieldList">
                                <el-option
                                    :key="obj.id"
                                    :label="obj.name"
                                    :value="obj.id"
                                    v-if="obj.type == 'department'"
                                    >
                                </el-option>
                            </template>
                        </el-select>
                        <br/>
                        请选择业务部门取值字段:
                        <el-select v-model="item.seriaNumberDepartTypeFormFieldIdValue" placeholder="请选择取值字段" v-if="item.seriaNumberDepartTypeFormFieldId" clearable @change="renderFieldList">
                            <el-option key="1" label="部门名称" value="1"></el-option>
                            <el-option key="2" label="部门简称" value="2"></el-option>
                            <el-option key="3" label="流水号标识" value="3"></el-option>
                            <el-option key="4" label="备注" value="4"></el-option>
                        </el-select>
                    </div>
                    <!-- 生效条件 -->
                    <div class="option-data-field">
                        <!-- 生效的字段 -->
                        生效的字段:
                        <el-select v-model="item.takeEffectField" placeholder="请选择生效的字段" clearable @change="buildTakeEffectFieldOptions(item)">
                            <template  v-for="obj in formLevelFieldList" >
                                <el-option
                                :key="obj.id"
                                :label="obj.name"
                                :value="obj.id"
                                v-if="obj.type === 'select' || (obj.type === 'category' && obj.options.config.type==='single')"
                                >
                                </el-option>
                            </template>
                        </el-select>
                        <!-- 生效字段的值 -->
                        <el-select v-model="item.takeEffectFieldValue" placeholder="请选择生效字段的值" clearable @change="renderFieldList" multiple>
                            <template  v-for="obj in item.takeEffectFieldOptions" >
                                <el-option
                                :key="obj.id"
                                :label="obj.title"
                                :value="obj.value"
                                >
                                </el-option>
                            </template>
                        </el-select>
                        请选择流水号自增体取值方式:
                        <el-select v-model="item.seriaNumberAutoincrementType" placeholder="请选择取值字段"  clearable @change="renderFieldList">
                            <el-option key="1" label="部门自增体" value="1"></el-option>
                            <el-option key="2" label="流水号自增体" value="2"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="option-data-add">
                    <el-button @click="addSerialNumber">新增</el-button>
                </div>
            </div>
        </el-form-item>

      <el-form-item label="字典数据源" v-if="isShowDictionaryTree">
            <DictionaryTree ref="treeChild"
                :selectedNode='selectedNode'
                :popover="true"
                :fieldType="fieldSubType"
                :channelFlag="channelFlag"
                :defaultClass="'dictionary-tree-form'"
                :appId="appId"
                :field="field"
                @nodeClick="handleTreeNode"
            />
        </el-form-item>
        <el-form-item label="部门数据源" v-if="isShowDepartment">
            <Department ref="treeChild"
                :selectedNode='selectedNode'
                :popover="true"
                :fieldType="fieldSubType"
                :multiple="true"
                :isContainSelectHalfNode="true"
                @nodeClick="handleTreeNode"
            />
        </el-form-item>
        <el-form-item label="档案模板" v-if="isArchive&&!isShowMultiArchive">
              <ArchiveTemplateList ref="archiveTemplateList"
                  :field="field"
                  :selectedNode='selectedTemplateNode'
                  @nodeClick="handleArchiveTemplateChange"
              />
        </el-form-item>
         <el-form-item label="业务分类" v-if="isArchive && isShowMultiArchive">
              <BusinessTree ref="treeChild"
                :selectedNode='selectedTemplateNode'
                :popover="true"
                :fieldType="fieldSubType"
                :channelFlag="channelFlag"
                :defaultClass="'business-tree-form'"
                :appId="appId"
                @nodeClick="handleTreeNode"
            />
        </el-form-item>
        <el-form-item label="时分秒格式" v-if="isShowDate&&field.options.config.type==='dateTime'">
            <el-radio-group  v-model="field.options.ext3" size="mini" v-if="isShowDate&&field.options.config.type==='dateTime'">
                <el-radio label="">时分秒</el-radio>
                <el-radio label="1">时分</el-radio>
                <el-radio label="2">时</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="年月日格式" v-if="isShowDate&&field.options.config.type==='date'">
            <el-radio-group  v-model="field.options.ext3" size="mini" v-if="isShowDate&&field.options.config.type==='date'">
                <el-radio label="">年月日</el-radio>
                <el-radio label="1">年月</el-radio>
                <el-radio label="2">年</el-radio>
            </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="日期范围" v-if="isShowDate&&field.options.config.type==='date'">
            <el-radio-group  v-model="field.options.ext3" size="mini" v-if="isShowDate&&field.options.config.type==='date'">
                <el-radio label="">年月日</el-radio>
                <el-radio label="1">年月</el-radio>
                <el-radio label="2">年</el-radio>
            </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="默认值" v-if="isShowText || isShowSerialNumber"> -->
        <el-form-item label="默认值" v-if="isShowText || isShowDate || isShowUser || isShowNumber || isShowCalculation">
            <el-checkbox v-if="isShowDate" v-model="field.options.defaultValue" label="默认当前时间" name="type" @change="renderFieldList"></el-checkbox>
            <el-checkbox v-if="isShowDate" v-model="field.options.syncApproveTime" label="同步审批时间" name="type" @change="renderFieldList"></el-checkbox>
            <el-checkbox v-if="isShowDate" v-model="field.options.syncTaskTime" label="同步任务时间" name="type" @change="renderFieldList"></el-checkbox>
            <el-checkbox v-if="isShowDate" v-model="field.options.syncCreateDataTime" label="同步创建时间" name="type" @change="renderFieldList"></el-checkbox>
            <template v-else-if="isShowUser" >
                <el-checkbox v-model="field.options.defaultValue" label="默认当前登录人" name="type"></el-checkbox>
                <el-tooltip  content="点击设置人员岗位规则，则填写表单时，当前字段里的出现的人员范围会根据设置的岗位自动进行人员过滤" effect="light" placement="top">
                   <el-button type="primary" icon="el-icon-user-solid" @click="handleSaveUserPosition" circle></el-button>
                </el-tooltip>
            </template>
             <!-- $NUMBER-TYPE-ALLOW_TEXT$ 数字字段设置默认值为当前值时，该字段支持文本输入  -->
            <el-tooltip  v-else-if="isShowNumber" content="$NUMBER-TYPE-ALLOW_TEXT$ 设置默认值为当前值时，该数字字段支持文本输入" effect="light" placement="top">
              <el-input v-model="field.options.defaultValue" size="mini" ></el-input>
           </el-tooltip>
           <el-tooltip  v-else-if="isShowCalculation" content="建议整数输入数字类型作为默认值" effect="light" placement="top">
              <el-input v-model="field.options.defaultValue" size="mini" ></el-input>
          </el-tooltip>
            <!-- $PROCESSINSTANCE-NAME$ 当前字段所在表单出现在流程里时读取流程名称   -->
            <!-- $TASKINSTANCE-NAME$ 当前字段所在表单出现在任务里时读取任务名称   -->
            <el-tooltip v-else :content="defaultValueView" effect="light" placement="top">
                <el-input v-model="field.options.defaultValue" size="mini" placeholder="请输入默认值,长度200字以内" maxlength="200" show-word-limit></el-input>
            </el-tooltip>
        </el-form-item>
        <el-tooltip  :content="defaultValueView2" effect="light" placement="top">
            <el-form-item label="默认值" v-if="isShowSerialNumber">
                  <el-radio-group  v-model="field.options.defaultValue" size="mini" v-if="isShowSerialNumber">
                    <el-radio class='margin-right: 10px;' label="serialNumber">流水号</el-radio>
                    <el-radio class='margin-right: 10px;' label="processName">流程</el-radio>
                    <el-radio class='margin-right: 10px;' label="taskName">任务</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-tooltip>
        <el-form-item label="计算公式" v-if="isShowCalculation">
            <el-button type="primary" icon="el-icon-circle-plus" @click="handleSaveCalculation">编辑公式</el-button>
        </el-form-item>
        <el-form-item label="计算公式" v-if="isShowSubFormSummary">
            <el-button type="primary" icon="el-icon-circle-plus" @click="handleSaveSubFormSummary">编辑公式</el-button>
        </el-form-item>
        <template v-if="isShowNumber || isShowCalculation || isShowSubFormSummary">
          <el-form-item label="单位(后缀)">
              <el-input v-model="field.options.unit" size="mini" placeholder="" :disabled="field.options.percentage"></el-input>
          </el-form-item>
          <el-form-item label="保留几位小数" v-if="field.options.percentage!=true">
              <el-input v-model="field.options.decimal" size="mini" placeholder="" onkeyup="this.value=this.value.replace(/[^\d]/g,'');"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="子表单默认数据" v-if="isSubform">
          <el-button type="primary" icon="el-icon-setting" @click="handleSetDefault">设置默认数据</el-button>
        </el-form-item>
        <el-form-item label="" v-if="isSubform">
            <el-tooltip  content="一旦设置子表单应用于审批流，则在使用当前表单发起审批流之后，当前子表单字段会自动根据审批流里的审批人员按顺序增加到表单列" effect="light" placement="top">
              <el-checkbox v-model="field.options.defaultValue" label="应用于审批流" name="type" ></el-checkbox>
            </el-tooltip>
            <el-tooltip  content="禁止删除默认值，若选择是，则在表单编辑模式下，默认值没有删除按钮权限，无法做删除操作。默认可删除" effect="light" placement="top">
              <el-checkbox v-model="field.options.unDelDefaultValue" label="禁止删除默认值" name="type" ></el-checkbox>
            </el-tooltip>
            <el-tooltip  content="一旦设置子表单数据源，则根据选择的数据源对应的关联子表单字段，带出对应子表单字段里所有跟当前表单字段名称和类型相同的数据，进行自动赋值" effect="light" placement="top">
              <el-checkbox v-model="field.options.unique" label="子表单数据源" name="type" ></el-checkbox>
            </el-tooltip>
            <el-tooltip  content="一旦设置子表单同步审批意见，则此表单发起的审批和任务的审核意见每轮都会追加进子表单,且只允许5个字段：审核人、审核时间、审核结果、审核意见、数据来源，其中审核人为用户字段类型其余为文本数据类型" effect="light" placement="top">
              <el-checkbox v-model="field.options.synchronousApprovalComments" label="同步审批意见" name="type" @change="changeSynchronousApprovalComments"></el-checkbox>
            </el-tooltip>
            <el-tooltip  content="配置了限制条数则子表单数据在增加时不能超过此配置的数值" effect="light" placement="top">
              <el-checkbox v-model="field.options.isLimitNumData" label="限制条数" name="type" @change="renderFieldList"></el-checkbox>
            </el-tooltip>
            <el-input v-model="field.options.limitNums" v-if="field.options.isLimitNumData" size="mini" placeholder="" onkeyup="this.value=this.value.replace(/[^\d]/g,'');" @input="renderFieldList"></el-input>

            <el-form-item label="子表单数据关联字段" v-if="field.options.unique">
              <el-select v-model="field.options.formulaView" clearable placeholder="请选择"  @change="selectLinkSubformField">
                  <el-option
                      v-for="item in linkSubformFieldList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
              </el-select>
            </el-form-item>
        </el-form-item>
        <el-form-item label="生成方式" v-if="isShowSerialNumber">
            <el-radio-group  v-model="field.options.ext3" size="mini" @change="changeSerialNumberType" v-if="isShowSerialNumber">
                <el-radio label="">初始化即生成</el-radio>
                <el-radio label="1">手动生成</el-radio>
                <el-radio label="2">保存自动生成</el-radio>
                <el-radio label="4">审批流通过再生成</el-radio>
                <el-radio label="5">关联生成</el-radio>
                <el-radio label="6">满足字段值生成</el-radio>
            </el-radio-group>
            <el-tooltip  content="选择关联数据联动生成流水号，配置并选择关联数据字段表单和流水号字段，则在当前流水号字段值生成时，同步到关联数据字段表单的流水号字段" effect="light" placement="top" v-if="field.options.ext3=='5'">
                <el-button type="primary" icon="el-icon-connection" @click="handleSaveSerialNumberRelation" circle></el-button>
            </el-tooltip>
            <div class="option-data-field" v-if="field.options.ext3=='6'">
                <el-select v-model="field.options.seriaNumberGenerateFieldId" placeholder="请选择表单的关联字段" @change="changeSeriaNumberGenerateField">
                   <template v-for="item in formLevelFieldList">
                    <el-option
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-if="item.type == 'select' || (item.type == 'category' && item.options.config.type == 'single')"
                      >
                    </el-option>
                  </template>
                </el-select>
                <el-select multiple v-model="field.options.seriaNumberGenerateFieldIdValue" placeholder="请选择取值字段" v-if="field.options.seriaNumberGenerateFieldId">
                    <el-option  :label="item.title" :value="item.value" v-for="(item,ind) in field.options.seriaNumberGenerateFieldOptions" :key="ind"></el-option>
                </el-select>
            </div>
        </el-form-item>
        <el-form-item label="档案模板" v-if="isArchive&&!isShowMultiArchive">
            <el-radio-group v-model="field.options.profileTemplateType">
                <el-radio-button label="1" value="1">完全模式</el-radio-button>
                <el-radio-button label="2" value="2">简洁模式</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!isShowDivider" label="设置">
            <el-checkbox v-model="field.options.required" label="必填" name="type"></el-checkbox>
            <el-checkbox v-model="field.options.fieldReadOnly" label="只读" name="type" @change="renderValue"></el-checkbox>
            <el-checkbox v-if="field.type === 'businessTree'" v-model="field.options.isRelatedDepartments" label="启用关联部门" name="type"  @change="renderValue"></el-checkbox>
            <el-checkbox v-if="field.type === 'user'" v-model="field.options.showUserDetails" @change="renderValue">显示详细信息</el-checkbox>
            <el-checkbox v-model="field.options.ext1" label="超链接" name="type" v-if="isShowText"></el-checkbox>
            <el-checkbox v-model="field.options.percentage" label="显示百分比" name="type" v-if="isShowNumber || isShowCalculation" @change="dafSuff"></el-checkbox>
            <el-checkbox v-if="isShowNumber || isShowCalculation" v-model="field.options.moneyFormat" label="金额千分位显示" name="type"></el-checkbox>
            <el-tooltip  content="每次查看，显示的是当前系统日期" effect="light" placement="top">
                <el-checkbox v-if="isShowDate" v-model="field.options.lastDateView" label="显示最新日期" name="type"></el-checkbox>
            </el-tooltip>
            <el-tooltip  content="自动读取表单字段的某个日期字段，并且根据配置的计算规则得到新日期" effect="light" placement="top">
                <el-checkbox v-if="isShowDate" v-model="field.options.isDynamicAssignmentDate" label="动态赋值日期" name="type"></el-checkbox>
            </el-tooltip>
            <div class="dynamicAssignmentDate" v-if="field.options.isDynamicAssignmentDate">
                源日期字段:               
                <el-select v-model="field.options.dynamicAssignmentDateSourceFieldId" placeholder="请选择表单的日期字段" @change="changeSeriaNumberGenerateField">
                   <template v-for="item in dateFieldList">
                    <el-option
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      >
                    </el-option>
                  </template>
                </el-select>
                <br/>
                <!-- 年:<el-input type="number" v-model="field.options.dynamicAssignmentDateYear"></el-input>
                月:<el-input type="number" v-model="field.options.dynamicAssignmentDateMonth"></el-input> -->
                日:<el-input type="number" v-model="field.options.dynamicAssignmentDateDay" @input="renderFieldList"></el-input>
            </div>
            <el-tooltip  content="输入内容后，会模糊查询出系统中录入过的数据，然后从列表中选择需要的即可" effect="light" placement="top">
                <el-checkbox v-if="isShowText" v-model="field.options.autoComplete" label="自动补全" name="type"></el-checkbox>
            </el-tooltip>
            <div class="cascade-field" v-if="field.options.autoComplete">
                <el-select 
                      v-model="field.options.cascadeShowField" 
                      clearable 
                      filterable
                      :multiple="true"
                      placeholder="请选择级联显示的字段" 
                      @change="renderFieldList"
                      >
                      <el-option 
                          v-for="item in fieldsList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      />
                  </el-select>
            </div>

            
            <el-tooltip  content="根据选择的字段进行跨年统计计算，用于工龄、年龄等需要根据当前日期进行计算后获得的值" effect="light" placement="top">
                <el-checkbox v-if="isShowNumber" v-model="field.options.crossCountFlag" label="跨年统计" name="type"></el-checkbox>
            </el-tooltip>

            <template v-if="isShowNumber">
                <el-checkbox v-model="field.options.isProgress" label="进度条" name="type" ></el-checkbox>
                 <div v-if="field.options.isProgress" class="sel-content-item-line">
                  <el-select 
                      v-model="field.options.progressDateField" 
                      clearable 
                      filterable
                      :multiple="false"
                      placeholder="请选择进度关联的日期字段" 
                      >
                      <el-option 
                          v-for="item in dateFieldList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      />
                  </el-select>
              </div>
            </template>

            <div v-if="isShowNumber && field.options.crossCountFlag" class="process-data-link-config-body-item">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.crossCountFieldId" clearable placeholder="请选择关联字段">
                                  <el-option
                                    v-for="item in dateFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
                <el-select v-model="field.options.crossCountUnit" placeholder="请选择单位">
                  <el-option
                    v-for="item in crossCountOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- 取值范围begin -->
            <div v-if="isShowCalculation" class="process-data-link-config-body-item" :key="loadTimerCal">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-field">
                       <div class="content">
                            <div class="target-form-field">
                                <span class="ellipsis" style="width: 90px;">取值范围</span>
                            </div>
                       </div>
                    </div>
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.storeRule" clearable placeholder="请选择">
                                  <el-option
                                    v-for="item in storeRuleOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!-- 取值范围end -->
            <el-tooltip effect="dark" v-if="field.type === 'link'" content="勾选后，点击关联数据默认查询全部" placement="top">
                <el-checkbox v-model="field.options.prohibitPaging" @change="renderFieldList">展现全部数据</el-checkbox>
            </el-tooltip>
            <!-- 数据联动字段关联 -->
            <div class="show-data-filter" v-if="field.type === 'link'">
                <el-tooltip effect="dark" content="自动带出条件数据配置好的默认搜索条件数据" placement="top">
                    <el-checkbox v-model="field.options.automaticRecode" @change="limitData">自动带出条件数据</el-checkbox>
                </el-tooltip>
            </div>
            <div class="show-data-filter" v-if="field.type === 'link' || field.type === 'select' || field.type === 'user' || field.type === 'department'">
                <el-tooltip effect="dark" content="选择此数据后自动带出配置好的关联的字段数据" placement="top">
                    <el-checkbox v-model="field.options.automaticRecodeRefField" @change="changeAutomaticRecodeRefField">级联带出关联数据条件数据</el-checkbox>
                </el-tooltip>
                <div class="automaticRecodeRefFieldBox" v-if="field.options.automaticRecodeRefField">
                    <el-select v-model="field.options.automaticRecodeFields" placeholder="请选择" multiple @change="changeAutomaticRecodeRefField">
                        <el-option
                        v-for="item in fieldsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-if="item.type==='link'"
                        >
                        </el-option>
                    </el-select>
                </div>
                <el-checkbox v-model="field.options.prohibitAdd" @change="renderFieldList" v-if="field.type === 'link'">禁止新增数据</el-checkbox>
                <el-tooltip effect="dark" v-if="field.type === 'link'" content="假如设置了数据选择限制，那么有两种用法：1.假如选择的是下拉、选项类型的字段，并设置对应状态值，那么在选择符合设置条件的数据时，系统会提示'所选数据存在【--设置对应状态-】限制不可被选中,有问题请联系系统管理员'；2.假如设置的是子表单字段数据，那么当前关联的数据会自动根据子表设置条件进行过滤符合设置条件的数据，一般用作人员数据过滤，例如：只能发起申请人为自己的提成，只能查看自己作为项目成员参与的项目列表。" placement="top">
                    <el-checkbox v-model="field.options.limitData" @change="renderFieldList">数据选择限制</el-checkbox>
                </el-tooltip>
                <div class="limit-data-set-content" v-if="field.options.limitData" :key="renderTimer">
                    <div class="limit-data-set-content-item" v-for="(it,index) in field.options.limitFieldDataArray" :key="index">
                        <div class="option-data">
                            <div class="option-data-user">
                                <el-select v-model="it.linkPropFieldId" placeholder="请选择级联字段" @change="changeLinkeField(it)">
                                   <el-option
                                      v-for="item in linkPropField"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id"
                                      >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-data-field">
                                <div class="" v-if="it.type && it.type==='select'">
                                    <el-select  v-model="it.selectLimitFieldData"  clearable filterable allow-create default-first-option placeholder="请选择" @change="changeLinkeFieldValue">
                                        <el-option v-for="item in it.linkPropFieldObj.options.config.options" :key="item.value" :label="item.title" :value="item.value" />
                                    </el-select>
                                </div>
                                <div class="" v-if="it.type && it.type==='subform'">
                                  <el-select  v-model="it.subFormFieldId"  clearable filterable allow-create default-first-option placeholder="请选择" @change="changeLinkeFieldValue">
                                      <el-option v-for="item in linkSubformPropField" :key="item.id" :label="item.name" :value="item.id" />
                                  </el-select> 
                              </div>
                      <!--          <div class="" v-if="it.type && it.type==='user'">
                                     用户
                                </div> -->
                                <div class="" v-if="it.type && (it.type==='text' || it.linkPropFieldObj.type==='number' || it.linkPropFieldObj.type==='calculation')">
                                   <el-input v-model="it.selectLimitFieldData" />
                                </div>
                                <div v-if="it.type && it.type==='category'">
                                    <div class="" v-if="it.linkPropFieldObj.options.config.type==='single'">
                                        <el-radio-group v-model="it.selectLimitFieldData" >
                                          <el-radio-button  v-for="(item, index) in it.linkPropFieldObj.options.config.options" :key="index" :label="item.value">
                                             {{ item.title }}
                                          </el-radio-button>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="option-btn">
                            <el-button @click="delLinkDateLimit(it)">删除</el-button>
                        </div>
                    </div>
                    <div class="option-data-add">
                        <el-button @click="addLinkDateLimit">新增</el-button>
                    </div>
                </div>
            </div>


            <el-tooltip  content="如果任务关联了该表单，将会把任务按钮状态同步给当前字段（依照任务按钮名称与当前字段下拉值进行匹配同步）。" effect="light" placement="top">
                <el-checkbox v-if="isShowSelect" v-model="field.options.synTaskBtnState" label="同步任务按钮状态" name="type" ></el-checkbox>
            </el-tooltip>
            <el-tooltip  content="如果表单发起了审批流，将会把审批流状态同步给当前字段" effect="light" placement="top">
                <el-checkbox v-if="isShowSelect || isShowCategory" v-model="field.options.synApprovalState" label="同步审批流状态" name="type" ></el-checkbox>
            </el-tooltip>

            <div v-if="(isShowSelect || isShowCategory) && field.options.synApprovalState" class="process-data-link-config-body-item" v-for="(obj,index) in approvalLinkState" :key="index">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-field">
                       <div class="content">
                            <div class="target-form-field">
                                <span class="ellipsis" style="width: 90px;">{{ obj.sourceLabel }}</span>
                            </div>
                       </div>
                    </div>
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="obj.targetKey" clearable placeholder="请选择映射字段" @change="changeTargetField(obj)">
                                  <el-option
                                    v-for="item in categoryList"
                                    :key="item.value"
                                    :label="item.title"
                                    :value="item.value">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!--关联配置begin-->
            <el-tooltip  content="选择关联字段后，同步更新当前字段。用字段名来匹配更新。目前支持关联数据、数据字典两种类型。关联数据取对应字段的值，数据字典取[标准来源]完成级联赋值" effect="light" placement="top">
                <el-checkbox v-if="isShowText || isShowDate || isShowSelect || isSubform || isShowUser || isShowDepartment || isShowNumber || isShowCalculation" v-model="synLinkFieldCheck" label="关联配置" name="type"></el-checkbox>
            </el-tooltip>
            <div v-if="(isShowText || isShowDate || isShowSelect || isSubform || isShowUser || isShowDepartment || isShowNumber || isShowCalculation) && synLinkFieldCheck" class="process-data-link-config-body-item">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.synLinkField" clearable placeholder="请选择当前表单的关联字段" @change="changeMainLinkField">
                                  <el-option
                                    v-for="item in mainLinkFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                            <div class="target-form-field">
                              <el-select v-model="field.options.synLinkFormFieldId" clearable placeholder="请选择映射字段" @change="changeLinkFormField">
                                  <el-option
                                    v-for="item in linkFormFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!--关联配置end-->
            <!--关联数据源配置begin-->
            <el-tooltip  content="选择关联数据源后，下拉选项值从关联字段的值中选择。" effect="light" placement="top">
                <el-checkbox v-if="isShowSelect" v-model="dataSourceFieldCheck" label="关联数据源" name="type"></el-checkbox>
            </el-tooltip>
            <div v-if="isShowSelect && dataSourceFieldCheck" class="process-data-link-config-body-item">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.dataSourceFieldId" clearable placeholder="请选择当前表单的关联字段" @change="changeMainLinkField2">
                                  <el-option
                                    v-for="item in mainLinkFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                            <div class="target-form-field">
                              <el-select v-model="field.options.dataSourceSubFieldId" clearable placeholder="请选择关联表单的子表单字段" @change="changeLinkSubFormField">
                                  <el-option
                                    v-for="item in mainLinkSubFormFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!--关联配置end-->
            <!--关联金额字段配置begin-->
            <el-tooltip  content="选择关联的数字字段，则将关联的数字字段值转为大写显示在此处" effect="light" placement="top">
                <el-checkbox v-if="isShowText" v-model="upMoneyFieldCheck" label="金额大写配置" name="type"></el-checkbox>
            </el-tooltip>
            <div v-if="isShowText && upMoneyFieldCheck" class="process-data-link-config-body-item">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.upMoneyField" clearable placeholder="请选择关联字段">
                                  <el-option
                                    v-for="item in moneyFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!--关联金额字段配置end-->
            <!--部门级联配置begin-->
            <el-tooltip  content="选择级联的显示的上级部门字段后，当前字段的数据源会根据上级选择的部门进行过滤显示。" effect="light" placement="top">
                <el-checkbox v-if="isShowDepartment" v-model="cascadeDeptFieldCheck" label="级联部门配置" name="type"></el-checkbox>
            </el-tooltip>
            <div v-if="isShowDepartment && cascadeDeptFieldCheck" class="process-data-link-config-body-item">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.cascadeDeptField" clearable placeholder="请选择关联字段">
                                  <el-option
                                    v-for="item in deptFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!--部门级联配置end-->
            <!--部门负责人级联赋值begin-->
            <el-tooltip  content="选择级联的显示的上级部门字段后，当前字段的数据源会根据上级选择的部门进行过滤显示。" effect="light" placement="top">
                <el-checkbox v-if="isShowDepartment && field.options.config.type === 'single'" v-model="field.options.masterUserDeptFieldCheck" label="部门负责人级联赋值" @change="renderFieldList()" ></el-checkbox>
            </el-tooltip>
            <div v-if="isShowDepartment && field.options.masterUserDeptFieldCheck && field.options.config.type === 'single'" class="process-data-link-config-body-item">
                <div class="process-data-link-config-body-item-top">
                    <div class="target-config">
                       <div class="content">
                            <div class="target-form-field">
                              <el-select v-model="field.options.masterUserDeptField" clearable placeholder="请选择要赋值的用户字段" @change="renderFieldList()">
                                  <el-option
                                    v-for="item in masterUserFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                              </el-select>
                            </div>
                       </div>
                    </div>
                </div>
            </div>
            <!--部门负责人级联赋值end-->

            <el-tooltip  content="勾选后，选择部门数据的时候无法选中父节点数据,只允许选中子节点" effect="light" placement="top">
                <el-checkbox v-if="isShowDepartment && field.options.config.type === 'single'" v-model="field.options.departChooseSonNode" label="只允许选择子节点" @change="renderFieldList()" ></el-checkbox>
            </el-tooltip>

            <el-tooltip  content="勾选后，选择字典数据的时候无法选中父节点数据,只允许选中子节点" effect="light" placement="top">
                <el-checkbox v-if="isShowDictionaryTree && field.options.config.type === 'single'" v-model="field.options.dictionaryTreeChooseSonNode" label="只允许选择子节点" @change="renderFieldList()" ></el-checkbox>
            </el-tooltip>
            
            <el-tooltip  content="勾选后，选择字典数据的时候无法选中子节点数据,只允许选中父节点" effect="light" placement="top">
                <el-checkbox v-if="isShowDictionaryTree && field.options.config.type === 'single'" v-model="field.options.dictionaryTreeChooseParentNode" label="只允许选择父节点" @change="renderFieldList()" ></el-checkbox>
            </el-tooltip>

            <el-tooltip  content="勾选后，选择业务分类数据的时候无法选中父节点数据,只允许选中子节点" effect="light" placement="top">
                <el-checkbox v-if="field.type === 'businessTree'" v-model="field.options.businessTreeChooseSonNode" label="只允许选择子节点" @change="renderFieldList()" ></el-checkbox>
            </el-tooltip>
            
            <el-tooltip  content="勾选后，选择业务分类数据的时候无法选中子节点数据,只允许选中父节点" effect="light" placement="top">
                <el-checkbox v-if="field.type === 'businessTree'" v-model="field.options.businessTreeChooseParentNode" label="只允许选择父节点" @change="renderFieldList()" ></el-checkbox>
            </el-tooltip>

            <div class="addressLevel" v-if="field.type === 'address'" >
                <el-select v-model="field.options.addressLevel" placeholder="请选择地址数据级别" @change="renderFieldList()">
                  <el-option key="1" value="1" label="省-市"></el-option>
                  <el-option key="2" value="2" label="省-市-县"></el-option>
                </el-select>
            </div>
            <!-- 数据联动字段关联 -->
           <div class="relation-data-set" v-if="field.type === 'user'">
                <el-checkbox v-model="field.options.setDataRelation" @change="changeUserRefData">人员数据联动</el-checkbox>
                <div class="relation-data-set-content" v-if="field.options.setDataRelation">
                    <div class="relation-data-set-content-item" v-for="(it,index) in field.options.userFieldDataRelation" :key="index">
                        <div class="option-data">
                            <div class="option-data-user">
                                <el-select v-model="it.userFieldId" placeholder="请选择人员字段" @change="changeUserField(it)">
                                   <el-option
                                      v-for="item in userFieldList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id"
                                      >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="option-data-field">
                               <el-select v-model="it.formFieldId" placeholder="请选择表单的关联字段" @change="changeFormField(it)">
                                   <el-option
                                      v-for="item in formLevelFieldList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id"
                                      v-if="item.type !=='user' "
                                      >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="field-data-field">
                                <el-input v-model="it.formFieldFilter" placeholder="请输入过滤关键字" style="width: 170px;" @change="changeFormField(it)"></el-input>
                                <el-tooltip class="item" effect="dark" content="不包含过滤关键字的数据不会被赋值" placement="top">
                                  <i class="el-icon-question"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="option-btn">
                            <el-button @click="delUserFieldDataRelation(it)">删除</el-button>
                        </div>
                    </div>
                    <div class="option-data-add">
                        <el-button @click="addUserFieldDataRelation">新增</el-button>
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item v-if="isShowNumber || isShowCalculation" label="高级">
             <div class="num-content-item">
                <div class="left">
                   <el-input v-model="tempNumVal" size="mini" placeholder="请输入临界值">
                        <template slot="prepend">临界值</template>
                    </el-input>
                </div>
                <div class="right">
                    <el-color-picker v-model="tempNumColor" show-alpha :predefine="predefineColors"></el-color-picker>
                </div>
              </div>
              <el-form-item label="校验规则" v-if="isShowNumber">
                <el-tooltip  content="如果字段设置了校验规则，假如当前字段值不满足验证公式，则当前表单数据不能保存。" effect="light" placement="top">
                  <el-button type="primary" icon="el-icon-circle-plus" @click="handleSaveValidation">校验规则</el-button>
                </el-tooltip>
              </el-form-item>
        </el-form-item>
        <!-- 定位 -->
         <el-form-item v-if="isShowLocation" label="高级">
             <div class="location-pops">
                 <div class="location-pops-item">
                     <el-checkbox v-model="field.options.autoLocation" @change="renderValue">自动获取位置</el-checkbox>
                 </div>
                 <div class="location-pops-item">
                     <el-checkbox v-model="field.options.updateLocation" @change="renderValue">允许调整</el-checkbox>
                 </div>
                 <div class="location-pops-item">
                     <el-checkbox v-model="field.options.showJwd" @change="renderValue">显示经纬度坐标</el-checkbox>
                 </div>
                 <div class="location-pops-item">
                     <el-checkbox v-model="field.options.locationRange" @change="renderValue">限制定位范围</el-checkbox>
                 </div>
                 <div class="location-pops-item" v-if="field.options.locationRange">
                    <el-button type="primary" @click="addLocationAddr">添加定位中心</el-button>
                 </div>
                 <div class="location-pops-item" v-if="field.options.locationCenter&&field.options.locationCenter.length>0">
                    <div class="locationCenter-item" v-for="(obj,index) in field.options.locationCenter" :key="index">
                        <div class="locationCenter-item-lable">
                            {{obj.nearestPOI}}
                        </div>
                        <div class="locationCenter-item-oprea">
                            <i class="el-icon-delete" @click="deleteLocationCenter(obj)"></i>
                        </div>
                    </div>
                 </div>
             </div>
         </el-form-item>
        <el-dialog
            title="添加定位中心"
            top="4vh"
            width="50vw"
            :visible.sync="active"
            v-if="active"
            append-to-body>
            <LocationConfig
                ref="detailRef"
                :locationInfo="locationInfo"
                @configLocationArray="configLocationArray"
                @hideSidebox="hideSidebox"/>
        </el-dialog>

         <el-dialog
            title="编辑计算公式"
            width="70%"
            top="5vh"
            append-to-body
            :visible.sync="isShowFormula">
            <Formula  ref="formula"  :field="field" :modelData="modelData" :fieldsList="this.modelData.fieldsList" :isSummary="isSummary" :content="content" :sourceOptions="sourceOptions" :subFieldSelected = "subFieldSelected"   />
            <span slot="footer" class="dialog-footer">
                <el-button v-if="channelFlag != 'CS'" @click="isShowFormula = false">取 消</el-button>
                <el-button v-if="channelFlag != 'CS'" type="primary" @click="saveFormula">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="编辑校验规则"
            width="70%"
            top="5vh"
            append-to-body
            :visible.sync="isShowFormulaValidation">
            <FormulaValidation  ref="formulaValidation"  :field="field" :modelData="modelData" :fieldsList="this.modelData.fieldsList" :isSummary="isSummary" :content="content" :sourceOptions="sourceOptions" :subFieldSelected = "subFieldSelected"   />
            <span slot="footer" class="dialog-footer">
                <el-button v-if="channelFlag != 'CS'" @click="isShowFormulaValidation = false">取 消</el-button>
                <el-button v-if="channelFlag != 'CS'" type="primary" @click="saveFormula">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="设置子表单初始值"
            width="100%"
            top="2vh"
            append-to-body
            :visible.sync="isShowSubForm">
            <el-form :model="formData.values" :ref="'customSubForm'" label-width="160px">
                <FieldSubform ref="fieldSubformRef" :subform="cloneField" :formData="formData.values"/>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="channelFlag != 'CS'" @click="isShowSubForm = false">取 消</el-button>
                <el-button v-if="channelFlag != 'CS'" type="primary" @click="saveSubFormDefault">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="编辑级联数据"
            :visible.sync="isShowCascaderTree"
            width="30%"
            append-to-body >
                <CascaderTree ref="cascaderTree" :defaultProps="{label:'title'}" :treeData="field.options.config.options"/>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="isShowCascaderTree = false">确 定</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="设置人员岗位规则"
            top="4vh"
            width="50vw"
            :visible.sync="isShowUserPosition"
            v-if="isShowUserPosition"
            append-to-body>
            <el-form-item label="关联字段">
              <el-select v-model="selectedPosition" filterable placeholder="请选择" multiple>
                  <el-option
                      v-for="item in positionList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  />
              </el-select>
            </el-form-item>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveSelectedPosition">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="设置级联更新流水号规则"
            top="4vh"
            width="50vw"
            :visible.sync="isShowSerialNumberRelation"
            v-if="isShowSerialNumberRelation"
            append-to-body>
            <el-form-item label="关联数据">
              <el-select v-model="serialNumberRefId" clearable placeholder="请选择" class="triggerSource" @change="changeSerialNumberRelationForm">
                  <el-option
                    v-for="item in targetLink"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流水号字段">
              <el-select v-model="serialNumberRelationFieldId" clearable placeholder="请选择" class="triggerSource"  @change="changeSerialNumberRelationField">
                  <el-option
                    v-for="item in targetOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveSelectedSerialNumberRelation">确 定</el-button>
            </span>
        </el-dialog>
    </el-form>

</template>

<script>
    import { isObjectLike, toNumber, cloneDeep, isEmpty } from 'lodash';
    import FieldCategory from '@/components/FieldCategory';
    import BusinessTree from '@/components/BusinessTree';
    import SerialNumber from '@/components/SerialNumber';
    import DictionaryTree from '@/components/DictionaryTree';
    import FieldPropsLink from './FieldPropsLink';
    import FieldSubform from '@/components/FieldItem/FieldSubform';
    import User from '@/components/User';
    import Department from '@/components/Department';
    import Formula from '@/components/Formula';
    import FormulaValidation from '@/components/Formula/FormulaValidation';
    import ArchiveTemplateList from '@/components/ArchiveTemplateList';
    import CascaderTree from './CascaderTree';
    // import * as formBaseField from '@/components/CustomForm/formBaseField';
    import { getFieldListByMainFormFiedId, getFormFieldListByIds, getModelServiceList, getBIFormConfigs, getPositionList } from '@/data-model';
    import LocationConfig from './LocationConfig';
    import approvalInfoDefault from './approvalInfoDefault.json';
    import { getUUID } from '@/utils/grocer';

    export default {
        components: {
            FieldCategory,
            BusinessTree,
            SerialNumber,
            DictionaryTree,
            User,
            Department,
            FieldPropsLink,
            Formula,
            FormulaValidation,
            FieldSubform,
            CascaderTree,
            ArchiveTemplateList,
            LocationConfig
        },
        data () {
            return {
                crossCountOptions: [{value: 0, label: '年'}, {value: 1, label: '月'}],
                dateFieldList: [], // 日期字段List
                storeRuleOptions: [{value: 0, label: '实际值'}, {value: 1, label: '大于等于零'}],
                mainLinkSubFormFieldList: [],
                // mainFieldList: [],
                // mainSubFieldList: [],
                dataSourceFieldCheck: false, // 关联数据源配置
                linkFormFieldList: [], // 关联表单的字段list
                deptFieldList: [], // 部门字段
                masterUserFieldList: [], // 用户字段
                cascadeDeptFieldCheck: false, // 部门级联配置
                moneyFieldList: [], // 金额字段List
                upMoneyFieldCheck: false, // 关联金额字段配置
                mainLinkFieldList: [], // 关联字段List
                synLinkFieldCheck: false, // 关联配置
                approvalLinkState: [{sourceKey: 1, sourceLabel: '审批中', targetKey: '', targetLabel: ''}, {sourceKey: 2, sourceLabel: '通过', targetKey: '', targetLabel: ''}, {sourceKey: 3, sourceLabel: '驳回', targetKey: '', targetLabel: ''}],
                linkSubformFieldList: [], // 子表单关联数据源字段，表示子表单的数据从哪个关联字段里带出
                tempNumVal: '',
                tempNumColor: '',
                subFieldSelected: {},
                loadTimer: '',
                loadTimerCal: '',
                isSummary: false,
                rules: {},
                isShowFormula: false,
                isShowFormulaValidation: false,
                sourceOptions: [],
                content: {// 计算公式显示内容
                    txt: ''
                },
                componentName: this.field.name,
                isShowSubForm: false,
                isShowCascaderTree: false,
                isShowSeriaConfig: false,
                isShowSeriaSelectFieldConfig: false,
                isShowSeriaBusinessTypeConfig: false,
                isShowSeriaDepartTypeConfig: false,
                formData: {},
                cloneField: {},
                defaultValueView: '$PROCESSINSTANCE-NAME$ 当前字段所在表单出现在流程里时读取流程名称, $TASKINSTANCE-NAME$ 当前字段所在表单出现在任务里时读取任务名称, $HYPERLINKS-NAME-READONLY$ 当前字段为超链接类型时，名称部分只读，名称部分从地址栏部分同步获取',
                defaultValueView2: '流水号：默认根据流水号规则生成；流程：当前字段所在表单出现在流程里时读取流程名称；任务：当前字段所在表单出现在任务里时读取任务名称',
                isPay: -1, // 企业是否为付款企业，0:未付款，1：已付款
                predefineColors: [
                    '#ecf5ff',
                    '#f0f9eb',
                    '#f4f4f5',
                    '#fdf6ec',
                    '#fef0f0',
                    '#409eff',
                    '#67c23a',
                    '#909399',
                    '#e6a23c',
                    '#f56c6c',
                    '#ff4500',
                    '#ff8c00',
                    '#ffd700',
                    '#90ee90',
                    '#00ced1',
                    '#c71585',
                    'rgba(255, 69, 0, 0.68)',
                    'rgb(255, 120, 0)',
                    'hsva(120, 40, 94, 0.5)',
                    'hsl(181, 100%, 37%)',
                    'hsla(209, 100%, 56%, 0.73)'
                ],
                active: false,
                locationInfo: {},
                locationCenter: [],
                positionList: [],
                isShowUserPosition: false,
                selectedPosition: [],
                userExtendConfig: {},
                userFieldList: [],
                formLevelFieldList: [],
                targetOptions: [],
                targetLink: [],
                isShowSerialNumberRelation: false,
                serialNumberRefId: '', // 当前表单关联数据字段id
                serialNumberRelationFormId: '', // 关联数据表单id
                serialNumberRelationFieldId: '', // 关联数据表单里对应级联的字段id
                linkPropField: [],
                linkSubformPropField: [],
                renderTimer: '',
                timeMoreSerialNumber: ''
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            modelData: {
                type: Object
            },
            channelFlag: { // 外部传入的渠道标识，默认是客户使用，US客户，CS客服
                type: String
            },
            appId: { // 外部传入的渠道标识，所属应用（客服系统过来用）
                type: String
            },
            fieldsList: {
                type: Array
            },
            relateModelList: {
                type: Array,
                default: []
            }
        },
        watch: {
            'field.options.config.type' (newVal, oldVal) {
                if (this.isArchive) {
                    this.field.options.config.options = [{title: '', value: '', def: false}];
                    this.field.options.defaultValue = '';
                } else if (newVal === 'image') { // 附件为图片时单列显示
                    this.field.options.unique = true;
                }
            },
            'tempNumVal' (newVal, oldVal) {
                this.field.options.numVal = newVal;
                if (this.field.options.ext2) {
                    let ext = JSON.parse(this.field.options.ext2);
                    ext.numVal = newVal;
                    this.field.options.ext2 = JSON.stringify(ext);
                }
            },
            'tempNumColor' (newVal, oldVal) {
                this.field.options.numColor = newVal;
                if (this.field.options.ext2) {
                    let ext = JSON.parse(this.field.options.ext2);
                    ext.numColor = newVal;
                    this.field.options.ext2 = JSON.stringify(ext);
                }
            },
            'field.options.unique' (newVal, oldVal) {
                if (this.isSubform) {
                    if (newVal) { // 子表单数据源选择
                        this.field.options.unique = true;
                        this.initLinkSubformFieldList();
                    } else {
                        this.field.options.unique = false;
                    }
                }
            },
            'field.options.fieldMaxLength' (newVal, oldVal) {
                if (newVal > 10000) {
                    this.field.options.fieldMaxLength = 10000;
                }
            },
            'synLinkFieldCheck' (newVal, oldVal) {
                if (!newVal) {
                    this.field.options.synLinkField = '';
                    this.field.options.synLinkFormFieldId = '';
                }
            },
            'dataSourceFieldCheck' (newVal, oldVal) {
                if (!newVal) {
                    this.field.options.dataSourceFieldId = '';
                    this.field.options.dataSourceSubFieldId = '';
                }
            },
            'field.options.isProgress' (newVal, oldVal) {
                newVal ? this.field.options.percentage = true : this.field.options.percentage = false;
            }
        },
        computed: {
            fieldSubType () {
                return this.field.options.config.type;
            },
            isShowText () { // 文本
                return this.field.type === 'text';
            },
            isShowNumber () { // 数字
                return this.field.type === 'number';
            },
            isShowCalculation () { // 计算
                this.loadTimerCal = new Date().getTime();
                return this.field.type === 'calculation';
            },
            isShowSubFormSummary () { // 子表计算统计
                return this.field.type === 'subFormSummary';
            },
            isShowDate () { // 时间
                return this.field.type === 'date';
            },
            isShowCategory () { // 选项
                return this.field.type === 'category';
            },
            isShowSelect () { // 下拉
                return this.field.type === 'select';
            },
            isShowFile () { // 文件
                return this.field.type === 'file';
            },
            isShowBusinessTree () { // 业务分类
                return this.field.type === 'businessTree';
            },
            isShowSerialNumber () { // 流水号
                return this.field.type === 'serialNumber';
            },
            isShowDictionaryTree () { // 数据字典
                return this.field.type === 'dictionary';
            },
            isShowUser () { // 用户
                return this.field.type === 'user';
            },
            isShowProcess () { // 所属流程
                return this.field.type === 'process';
            },
            isShowAddr () { // 地址
                return this.field.type === 'addr';
            },
            isShowCascader () { // 下拉
                return this.field.type === 'cascader';
            },
            isShowDivider () { // 分割线
                return this.field.type === 'divider';
            },
            isShowDepartment () { // 部门
                return this.field.type === 'department';
            },
            isShowLocation () { // 定位
                return this.field.type === 'location';
            },
            isShowLink () { // 关联字段
                this.loadTimer = new Date().getTime();
                return this.field.type === 'link';
            },
            isSubform () { // 是否子表单
                return this.field.type === 'subform';
            },
            isArchive () { // 是否档案文件
                return this.field.type === 'archive';
            },
            categoryList () {
                return this.field.options.config.options;
            },
            isShowMultiArchive () {
                if (this.isArchive) {
                    if (this.field.options.config.type === 'single') { // 单选
                        return false;
                    } else if (this.field.options.config.type === 'multi') { // 按业务分类选
                        return true;
                    }
                }
            },
            selectedNode () {
                if (this.field.type === 'user') {

                } else if (this.field.options.config.type === 'single' || this.isShowSerialNumber || (this.field.options.config.type === 'multi' && this.isShowDictionaryTree)) {
                    if (this.field.options.config.options[0]) {
                        setTimeout(() => { // 调用子组件的方法
                            this.$refs.treeChild._refreshSelectedNode(this.field.options.config.options[0]);
                        }, 0);
                        return {
                            id: toNumber(this.field.options.config.options[0].value),
                            label: this.field.options.config.options[0].title
                        };
                    } else {
                        return {
                            id: 0,
                            lable: ''
                        };
                    }
                }
            },
            selectedTemplateNode () {
                if (this.field.options.config.options[0]) {
                    return {
                        id: this.field.options.config.options[0].value,
                        label: this.field.options.config.options[0].title
                    };
                } else {
                    return {
                        id: '',
                        lable: ''
                    };
                }
            }
        },
        created () {
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.isPay = currentUserInfo.companyInfo.isPay;
            }
            if (this.field.type === 'number' || this.field.type === 'calculation' || this.field.type === 'location') {
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let ext = JSON.parse(ext2);
                    this.tempNumVal = ext.numVal;
                    this.tempNumColor = ext.numColor;
                    if (this.field.type === 'location') {
                        this.field.options.autoLocation = ext.autoLocation;
                        this.field.options.locationCenter = ext.locationCenter;
                        this.field.options.locationRange = ext.locationRange;
                        this.field.options.updateLocation = ext.updateLocation;
                        this.field.options.showJwd = ext.showJwd;
                        this.locationCenter = ext.locationCenter;
                    }
                }
            }
            if (this.field.type === 'subform') {
                if (this.field.options.unique) { // 子表单数据源选择
                    this.initLinkSubformFieldList();
                }
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.synchronousApprovalComments) {
                        this.field.options.synchronousApprovalComments = extObj.synchronousApprovalComments;
                    }
                    if (extObj.isLimitNumData) {
                        this.field.options.isLimitNumData = extObj.isLimitNumData;
                        this.field.options.limitNums = extObj.limitNums;
                    }
                }
            }
            if (this.field.type === 'select' && this.field.options.synApprovalState) {
                if (this.field.options.stateLinkConfig) {
                    this.approvalLinkState = JSON.parse(this.field.options.stateLinkConfig);
                } else {
                    this.field.options.stateLinkConfig = JSON.stringify(this.approvalLinkState);
                }
            }

            if (this.field.type === 'text' || this.field.type === 'select' || this.field.type === 'subform' || this.field.type === 'user' || this.field.type === 'department' || this.field.type === 'number' || this.field.type === 'calculation' || this.field.type === 'date') {
                // 文本字段映射关联字段配置
                if (this.field.options.synLinkField) {
                    this.synLinkFieldCheck = true;
                    // 初始化关联表单字段list用于选项反显
                    this.changeMainLinkField();
                }
                this.initLinkformFieldList();
                // 文本字段映射金额配置（显示金额大写）
                if (this.field.options.upMoneyField) {
                    this.upMoneyFieldCheck = true;
                }
                this.initMoneyFieldList();
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let ext = JSON.parse(ext2);
                    if (ext.fieldMaxLength) {
                        this.field.options.fieldMaxLength = ext.fieldMaxLength;
                    }
                }
                // 跨年统计计算字段
                if (this.field.type === 'number' || this.field.type === 'date') {
                    this.initDateFieldList();
                }
            }
            if (this.field.type === 'select') {
                // 选项字段关联数据源配置
                if (this.field.options.dataSourceFieldId) {
                    this.dataSourceFieldCheck = true;
                    // 初始化关联表单字段list用于选项反显
                    this.changeMainLinkField2();
                }
                this.initLinkformFieldList2();
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.automaticRecode) { // 自动带出关联
                        this.field.options.automaticRecode = true;
                    }
                    if (extObj.automaticRecodeRefField) { // 自动级联关联
                        this.field.options.automaticRecodeRefField = true;
                        if (extObj.automaticRecodeFields) {
                            this.field.options.automaticRecodeFields = extObj.automaticRecodeFields.split(',');
                        }
                    }
                }
            }
            if (this.field.type === 'user') {
                this.initFormLevelFieldList();
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let ext = JSON.parse(ext2);
                    if (ext.showUserDetails) {
                        this.field.options.showUserDetails = ext.showUserDetails;
                    }
                    if (ext.automaticRecodeRefField) { // 自动级联关联
                        this.field.options.automaticRecodeRefField = true;
                        if (ext.automaticRecodeFields) {
                            this.field.options.automaticRecodeFields = ext.automaticRecodeFields.split(',');
                        }
                    }
                }
            }
            if (this.field.type === 'text') {
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let ext = JSON.parse(ext2);
                    if (ext.cascadeShowField) {
                        this.field.options.cascadeShowField = ext.cascadeShowField;
                    }
                }
            }
            if (this.field.type === 'address') {
			    let ext2 = this.field.options.ext2;
			    if (ext2) {
			        let ext = JSON.parse(ext2);
			        if (ext.addressLevel) {
			            this.field.options.addressLevel = ext.addressLevel;
			        }
			    }
            }
            if (this.field.type === 'businessTree') {
			    let ext2 = this.field.options.ext2;
			    if (ext2) {
			        let ext = JSON.parse(ext2);
			        if (ext.isRelatedDepartments) {
			            this.field.options.isRelatedDepartments = ext.isRelatedDepartments;
			        }
			    }
            }
            if (this.field.type === 'department') {
                // 级联部门配置
                if (this.field.options.cascadeDeptField) {
                    this.cascadeDeptFieldCheck = true;
                }
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.masterUserDeptFieldCheck) { // 部门负责人赋值
                        this.field.options.masterUserDeptField = extObj.masterUserDeptField;
                        this.field.options.masterUserDeptFieldCheck = extObj.masterUserDeptFieldCheck;
                    }
                    if (extObj.departChooseSonNode) { // 只允许选择子节点
                        this.field.options.departChooseSonNode = extObj.departChooseSonNode;
                    }
                    if (extObj.automaticRecodeRefField) { // 自动级联关联
                        this.field.options.automaticRecodeRefField = true;
                        if (extObj.automaticRecodeFields) {
                            this.field.options.automaticRecodeFields = extObj.automaticRecodeFields.split(',');
                        }
                    }
                }
                this.initDeptFieldList();
            }
            if (this.field.type === 'date') {
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.syncApproveTime) { // 同步审批时间
                        this.field.options.syncApproveTime = extObj.syncApproveTime;
                    }
                    if (extObj.syncTaskTime) { // 同步任务时间
                        this.field.options.syncTaskTime = extObj.syncTaskTime;
                    }
                    if (extObj.syncCreateDataTime) { // 同步数据创建时间
                        this.field.options.syncCreateDataTime = extObj.syncCreateDataTime;
                    }
                }
            }
            if (this.field.type === 'link') {
                if (this.field.options.config.form.selectTableHeaderFields) {
                    this.field.options.config.form.selectTableHeaderFieldsArray = this.field.options.config.form.selectTableHeaderFields.split(',');
                }
                this.initLimitData();
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.automaticRecode) { // 自动带出关联
                        this.field.options.automaticRecode = true;
                    }
                    if (extObj.automaticRecodeRefField) { // 自动级联关联
                        this.field.options.automaticRecodeRefField = true;
                        if (extObj.automaticRecodeFields) {
                            this.field.options.automaticRecodeFields = extObj.automaticRecodeFields.split(',');
                        }
                    }
                    if (extObj.prohibitAdd) {
                        this.field.options.prohibitAdd = true;
                    }
                }
            }
            if (this.field.type === 'serialNumber') {
                this.initFormLevelFieldList();
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let extObj = JSON.parse(ext2);
                    if (extObj.seriaNumberFormFieldId) { // 流水号关联部门字段,
                        this.isShowSeriaConfig = true;
                    }
                    if (extObj.seriaNumberBusinessTypeFormFieldId) { // 流水号关联业务分类
                        this.isShowSeriaBusinessTypeConfig = true;
                    }
                    if (extObj.seriaNumberDepartTypeFormFieldId) { // 流水号关联部门字段,
                        this.isShowSeriaDepartTypeConfig = true;
                    }
                    if (extObj.seriaNumberSelectTypeFormFieldId) { // 流水号关联部门字段,
                        this.isShowSeriaSelectFieldConfig = true;
                    }
                    // if (extObj.seriaNumberGenerateFieldId) { // 流水号关联部门字段,
                    //     this.seriaNumberGenerateFieldId = true;
                    // }
                }
            }
            // 回显只读
            //      let ext2 = this.field.options.ext2;
            //      if (ext2) {
			    // let ext = JSON.parse(ext2);
			    // if (ext.fieldReadOnly) {
			    //     this.field.options.fieldReadOnly = ext.fieldReadOnly;
			    // }
            //      }
            if (isEmpty(this.userExtendConfig)) {
                this.getUserFieldList();
            }
        },
        methods: {
            async initLinkSubformFieldList () {
                this.linkSubformFieldList = [];
                let fields = cloneDeep(this.fieldsList);
                for (let item of fields) {
                    if (item.type === 'link') {
                        if (item.options.config.form && !isEmpty(item.options.config.form.selectFormFields)) {
                            let targetFields = item.options.config.form.selectFormFields;
                            if (!isEmpty(item.options.config.form.selectTableHeaderFields)) {
                                targetFields = targetFields + ',' + item.options.config.form.selectTableHeaderFields;
                            }
                            let subformFields = await getFormFieldListByIds(targetFields);
                            for (let sf of subformFields) {
                                if (sf.type === 'subform') {
                                    sf.name = '【' + item.name + '】--' + sf.name;
                                    // 当前子表单id + 源关联字段id +源关联字段内子表单字段id
                                    sf.mainAndSubformFields = this.field.id + ',' + item.id + ',' + sf.id;
                                    this.linkSubformFieldList.push(sf);
                                }
                            }
                        }
                    }
                }
            },
            async initDeptFieldList () {
                this.deptFieldList = [];
                let fields = cloneDeep(this.fieldsList);
                for (let item of fields) {
                    if (item.type === 'department' && this.field.id !== item.id) {
                        this.deptFieldList.push(item);
                    }
                    if (item.type === 'user' && this.field.id !== item.id) {
                        this.masterUserFieldList.push(item);
                    }
                }
            },
            async initMoneyFieldList () {
                this.moneyFieldList = [];
                let fields = cloneDeep(this.fieldsList);
                for (let item of fields) {
                    if (item.type === 'number' || item.type === 'subFormSummary' || item.type === 'calculation') {
                        this.moneyFieldList.push(item);
                    }
                }
            },
            async initDateFieldList () {
                this.dateFieldList = [];
                let fields = cloneDeep(this.fieldsList);
                for (let item of fields) {
                    if (item.type === 'date' || item.type === 'dateTime' || item.type === 'daterange') {
                        this.dateFieldList.push(item);
                    }
                }
            },
            async initLinkformFieldList () {
                this.mainLinkFieldList = [];
                let fields = cloneDeep(this.fieldsList);
                for (let item of fields) {
                    if (item.type === 'link' || (item.type === 'dictionary' && item.options.config.type === 'single')) {
                        this.mainLinkFieldList.push(item);
                    }
                }
            },
            async changeMainLinkField () {
                // console.log(this.field.options.synLinkField);
                this.linkFormFieldList = [];
                if (this.field.options.synLinkField) {
                    let allFormFieldList = await getFieldListByMainFormFiedId(this.field.options.synLinkField);
                    if (allFormFieldList && allFormFieldList.length > 0) {
                        // 过滤出关联表单中的字段（不是分割线、不是子表单里的字段等）
                        allFormFieldList.forEach(field => {
                            if (field.type !== 'divider' && isEmpty(field.subFormFieldId)) {
                                this.linkFormFieldList.push(field);
                            }
                        });
                    }
                }
            },
            async changeLinkFormField () {
                // console.log(this.field.options.synLinkFormFieldId);
            },
            // ===================关联数据源配置begin====================================
            async initLinkformFieldList2 () {
                this.mainLinkFieldList = [];
                let fields = cloneDeep(this.fieldsList);
                for (let item of fields) {
                    if (item.type === 'link') {
                        this.mainLinkFieldList.push(item);
                    }
                }
            },
            async changeMainLinkField2 () {
                // console.log(this.field.options.dataSourceFieldId);
                this.mainLinkSubFormFieldList = [];
                if (this.field.options.dataSourceFieldId) {
                    let allFormFieldList = await getFieldListByMainFormFiedId(this.field.options.dataSourceFieldId);
                    if (allFormFieldList && allFormFieldList.length > 0) {
                        // 过滤出关联表单中的字段（不是分割线、不是子表单里的字段等）
                        allFormFieldList.forEach(field => {
                            if (field.type === 'subform') {
                                this.mainLinkSubFormFieldList.push(field);
                            }
                        });
                    }
                }
            },
            async changeLinkSubFormField () {
                // console.log(this.field.options.synLinkFormFieldId);
            },
            // ===================关联数据源配置end====================================
            configLocationArray (obj) {
                this.locationCenter.push(obj);
                this.field.options.locationCenter = cloneDeep(this.locationCenter);
                this.active = false;
            },
            selectLinkSubformField (val) {
                if (val) {
                    this.selected = this.linkSubformFieldList.find((item) => {
                        if (item.id === val) {
                            this.field.options.formulaExp = item.mainAndSubformFields;
                        };
                    });
                } else {
                    this.field.options.formulaExp = '';
                }
            },
            handleTreeNode (data, node, tree) {
                // 单选：
                if (this.field.options.config.type === 'single' || this.isShowSerialNumber || (this.field.type === 'dictionary' && this.field.options.config.type === 'multi') || (this.field.type === 'department' && this.field.options.config.type === 'multi') || (this.field.type === 'archive' && this.field.options.config.type === 'multi')) {
                    let obj = {};
                    for (const key in data) {
                        if (data.hasOwnProperty(key) && !isObjectLike(data[key])) {
                            obj = {
                                title: data.label,
                                value: data.id,
                                def: false
                            };
                        }
                    }
                    this.field.options.config.options = [obj];
                    this.field.options.defaultValue = data.label;
                }
                // 流水号
                if (this.field.type === 'serialNumber') {
                    if (data.center && data.center.indexOf('$department') !== -1) {
                        this.isShowSeriaConfig = true;
                    } else {
                        this.isShowSeriaConfig = false;
                    }
                    if (data.center && data.center.indexOf('$selectField') !== -1) {
                        this.isShowSeriaSelectFieldConfig = true;
                    } else {
                        this.isShowSeriaSelectFieldConfig = false;
                    }
                    if ((data.suffix && data.suffix.indexOf('$businessType') !== -1) ||
                         (data.prefix && data.prefix.indexOf('$businessType') !== -1) ||
                         (data.center && data.center.indexOf('$businessType') !== -1)) {
                        this.isShowSeriaBusinessTypeConfig = true;
                    } else {
                        this.isShowSeriaBusinessTypeConfig = false;
                    }
                    if ((data.suffix && data.suffix.indexOf('$departType') !== -1) ||
                         (data.prefix && data.prefix.indexOf('$departType') !== -1) ||
                         (data.center && data.center.indexOf('$departType') !== -1)) {
                        this.isShowSeriaDepartTypeConfig = true;
                    } else {
                        this.isShowSeriaDepartTypeConfig = false;
                    }
                }
            },
            handleArchiveTemplateChange (node) {
                let obj = {
                    title: node.label,
                    value: node.id,
                    def: false
                };
                this.field.options.config.options = [obj];
                this.field.options.defaultValue = obj.label;
            },
            handleTreeShow () {
                // this._initPage();
            },
            handleSaveCalculation () {
                this.isSummary = false;
                this.loadTimerCal = new Date().getTime();
                this.sourceOptions = [];
                this.content.txt = '';
                if (this.field.options.formulaView) {
                    this.content.txt = this.field.options.formulaView;
                }
                this.setSourceOptions(this.modelData.fieldsList);
                if (this.sourceOptions.lengh === 0) {
                    this.$message({message: '当前表单未定义数字类型字段', type: 'warning'});
                    return;
                }
                this.isShowFormula = true;
            },
            setSourceOptions (fieldsList) {
                fieldsList.forEach(item => {
                    if (item.type === 'number' || item.type === 'calculation' || item.type === 'subFormSummary') { // 仅支持数字类型的字段进行计算公式设计
                        let data = {type: 0};
                        data.id = item.id;
                        data.label = item.name;
                        if (item.id.length === 32) {
                            data.type = 1;
                        }
                        this.sourceOptions.push(data);
                    } else if (item.type === 'subform' && item.options.fieldList) {
                        this.setSourceOptions(item.options.fieldList);
                    }
                });
            },
            handleSaveSubFormSummary () {
                this.subFieldSelected = {};
                this.isSummary = true;
                this.loadTimer = new Date().getTime();
                this.sourceOptions = [];
                this.content.txt = '';
                if (this.field.options.formulaView) {
                    this.content.txt = this.field.options.formulaView;
                }
                this.setSubFormSourceOptions(this.modelData.fieldsList);
                if (this.sourceOptions.lengh === 0) {
                    this.$message({message: '当前表单未定义子表单', type: 'warning'});
                    return;
                }
                // 表达式
                let formulaExp = this.field.options.formulaExp;
                if (!isEmpty(formulaExp)) {
                    let aa = formulaExp.substr(0, 32);
                    if (this.sourceOptions && this.sourceOptions.length > 0) {
                        for (var i = 0; i < this.sourceOptions.length; i++) {
                            let subFieldList = this.sourceOptions[i].subFieldList;
                            for (var j = 0; j < subFieldList.length; j++) {
                                let subfield = subFieldList[j];
                                if (subfield.id === aa) {
                                    this.subFieldSelected = this.sourceOptions[i];
                                    break;
                                }
                            }
                        }
                    }
                }
                this.isShowFormula = true;
            },
            renderValue (e) {
                this.$emit('renderValue', cloneDeep(this.field));
            },
            setSubFormSourceOptions (fieldsList) {
                fieldsList.forEach(item => {
                    if (item.type === 'subform') {
                        let data = {type: 0};
                        data.id = item.id;
                        data.label = item.name;
                        if (item.id.length === 32) {
                            data.type = 1;
                        }
                        if (item.options.fieldList) {
                            let subFieldList = [];
                            item.options.fieldList.forEach(subItem => {
                                if (subItem.type === 'number' || subItem.type === 'calculation' || subItem.type === 'text') {
                                    let subdata = {type: 0};
                                    subdata.id = subItem.id;
                                    subdata.label = subItem.name;
                                    if (subItem.id.length === 32) {
                                        subdata.type = 1;
                                    }
                                    subFieldList.push(subdata);
                                }
                            });
                            data.subFieldList = subFieldList;
                        }
                        this.sourceOptions.push(data);
                    }
                });
            },
            handleSaveValidation () {
                this.isSummary = false;
                this.loadTimer = new Date().getTime();
                this.sourceOptions = [];
                this.content.txt = '';
                if (this.field.options.formulaView) {
                    this.content.txt = this.field.options.formulaView;
                }
                this.setSourceOptions(this.modelData.fieldsList);
                if (this.sourceOptions.lengh === 0) {
                    this.$message({message: '当前表单未定义数字类型字段', type: 'warning'});
                    return;
                }
                this.isShowFormulaValidation = true;
            },
            saveFormula () {
                // let formula = this.$refs.formula.transformFormula();// 每次切换model时清空显示字段
                let formula;// 每次切换model时清空显示字段
                let formulaSearch = [];
                if (this.isShowFormula) {
                    formula = this.$refs.formula.transformFormula();// 每次切换model时清空显示字段
                    formulaSearch = this.$refs.formula.getFormula();
                } else if (this.isShowFormulaValidation) {
                    formula = this.$refs.formulaValidation.transformFormula();// 每次切换model时清空显示字段
                }
                this.field.options.formulaExp = formula;
                this.field.options.formulaView = this.content.txt;
                this.field.options.formulaSearch = JSON.stringify(formulaSearch);
                this.isShowFormula = false;
                this.isShowFormulaValidation = false;
            },
            handleSetDefault () { // 设置子表单初始值
                this.renderdefaultForm();
                if (this.field.options.defaultSetting !== '' && this.field.options.defaultSetting !== undefined) {
                    let defaultValues = JSON.parse(this.cloneField.options.defaultSetting);
                    setTimeout(() => { // 默认回显值
                        this.$refs.fieldSubformRef.initDefaultSetting(defaultValues);
                    }, 0);
                }
                this.isShowSubForm = true;
            },
            saveSubFormDefault () { // 保存子表单初始值
                if (this.formData.values[this.field.id] != null) {
                    for (let i = 0; i < this.formData.values[this.field.id].length; i++) {
                        let cur = this.formData.values[this.field.id][i];
                        cur.isDefault = true;
                    }
                    this.field.options.defaultSetting = JSON.stringify(this.formData.values[this.field.id]);
                }
                this.isShowSubForm = false;
            },
            renderdefaultForm () {
                this.cloneField = cloneDeep(this.field);
                let values = {};
                values[this.field.id] = '';
                let fieldsList = this.cloneField.options.fieldList;
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    element.label = element.name;
                }
                this.formData = {
                    formId: this.cloneField.id,
                    values: values,
                    colSpan: this.cloneField.colSpan ? this.cloneField.colSpan : 1
                };
            },
            dafSuff () {
                if (this.field.options.percentage) {
                    this.field.options.unit = '%';
                    this.field.name = this.field.name + '(%)';
                } else {
                    // this.field.options.unit=this.field.options.unit;
                }
            },
            handleEditCascader () {
                this.isShowCascaderTree = true;
            },
            hideSidebox (flg) {
                this.active = false;
            },
            addLocationAddr () {
                this.active = true;
            },
            deleteLocationCenter (obj) {
                for (let i = 0; i < this.field.options.locationCenter.length; i++) {
                    let cur = this.field.options.locationCenter[i];
                    if (obj.id === cur.id) {
                        this.field.options.locationCenter.splice(i, 1);
                    }
                }
                this.field.options = cloneDeep(this.field.options);
            },
            changeTargetField () {
                for (let i = 0; i < this.approvalLinkState.length; i++) {
                    if (!isEmpty(this.approvalLinkState[i].targetKey)) {
                        for (let j = 0; j < this.categoryList.length; j++) {
                            if (this.approvalLinkState[i].targetKey === this.categoryList[j].value) {
                                this.approvalLinkState[i].targetLabel = this.categoryList[j].title;
                                break;
                            }
                        }
                    }
                }
                this.field.options.stateLinkConfig = JSON.stringify(this.approvalLinkState);
            },
            async handleSaveUserPosition () {
                this.isShowUserPosition = false;
                this.positionList = [];
                let formData = await getPositionList(Object.assign({}, {
                    currentPage: 0,
                    pageSize: 1000
                }, {}));
                let allPositionList = formData.data;
                for (let i = 0; i < allPositionList.length; i++) {
                    let node = allPositionList[i];
                    if (!node.root) {
                        this.positionList.push(node);
                    }
                }
                this.selectedPosition = [];
                if (this.field.ext1) {
                    this.selectedPosition = JSON.parse(this.field.ext1);
                }
                this.isShowUserPosition = true;
            },
            saveSelectedPosition () {
                this.isShowUserPosition = false;
                this.field.ext1 = JSON.stringify(this.selectedPosition);
            },
            async getUserFieldList (obj) {
                this.loading = true;
                let param = {};
                param.modelTypes = '7';
                let formData = await getModelServiceList(
                    Object.assign(
                        {
                            currentPage: 0,
                            pageSize: 10
                        },
                        param
                    )
                );
                if (formData.data.length > 0) {
                    this.userExtendConfig = formData.data[0];
                    let param = { formId: this.userExtendConfig.formId, BIDimension: 7 };
                    let field = await getBIFormConfigs(param);
                    this.userFieldList = field.allList;
                }
                this.loading = false;
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            addUserFieldDataRelation () {
                let obj = {};
                obj.id = this.generateUUID();
                obj.userFieldId = '';
                obj.formFieldId = '';
                let userFieldDataRelationArray = [];
                if (this.field.options.userFieldDataRelation) {
                    userFieldDataRelationArray = cloneDeep(this.field.options.userFieldDataRelation);
                }
                userFieldDataRelationArray.push(obj);
                this.field.options.userFieldDataRelation = userFieldDataRelationArray;
                // ext2新增数据
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let curExt = JSON.parse(ext2);
                    if (curExt) {
                        let userFieldDataRelations = curExt.userFieldDataRelation;
                        if (userFieldDataRelations) {
                            let ids = [];
                            for (let i = 0; i < userFieldDataRelations.length; i++) {
                                ids.push(userFieldDataRelations[i].id);
                            }
                            if (ids.indexOf(obj.id) == -1) {
                                userFieldDataRelations.push(obj);
                            }
                        }
                    }
                    this.field.options.ext2 = JSON.stringify(curExt);
                }
                this.renderValue(this.field);
            },
            addLinkDateLimit () {
                let obj = {};
                obj.id = this.generateUUID();
                obj.linkPropFieldId = '';
                obj.type = '';
                let limitFieldDataArray = [];
                if (this.field.options.limitFieldDataArray) {
                    limitFieldDataArray = cloneDeep(this.field.options.limitFieldDataArray);
                }
                limitFieldDataArray.push(obj);
                this.field.options.limitFieldDataArray = limitFieldDataArray;
                // ext2新增数据
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let curExt = JSON.parse(ext2);
                    if (curExt) {
                        let limitFieldDataArray = curExt.limitFieldDataArray;
                        if (limitFieldDataArray) {
                            let ids = [];
                            for (let i = 0; i < limitFieldDataArray.length; i++) {
                                ids.push(limitFieldDataArray[i].id);
                            }
                            if (ids.indexOf(obj.id) == -1) {
                                limitFieldDataArray.push(obj);
                            }
                        }
                    }
                    this.field.options.ext2 = JSON.stringify(curExt);
                }
                this.renderValue();
            },
            delLinkDateLimit (obj) {
                for (let i = 0; i < this.field.options.limitFieldDataArray.length; i++) {
                    if (obj.id == this.field.options.limitFieldDataArray[i].id) {
                        this.field.options.limitFieldDataArray.splice(i, 1);
                    }
                }
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let curExt = JSON.parse(ext2);
                    if (curExt) {
                        let limitFieldDataArray = curExt.limitFieldDataArray;
                        if (limitFieldDataArray) {
                            for (let i = 0; i < limitFieldDataArray.length; i++) {
                                if (obj.id == limitFieldDataArray[i].id) {
                                    limitFieldDataArray.splice(i, 1);
                                }
                            }
                        }
                    }
                    this.field.options.ext2 = JSON.stringify(curExt);
                }
                this.renderValue();
            },
            delUserFieldDataRelation (obj) { // ext2也要删除
                for (let i = 0; i < this.field.options.userFieldDataRelation.length; i++) {
                    if (obj.id == this.field.options.userFieldDataRelation[i].id) {
                        this.field.options.userFieldDataRelation.splice(i, 1);
                    }
                }
                let ext2 = this.field.options.ext2;
                if (ext2) {
                    let curExt = JSON.parse(ext2);
                    if (curExt) {
                        let userFieldDataRelations = curExt.userFieldDataRelation;
                        if (userFieldDataRelations) {
                            for (let i = 0; i < userFieldDataRelations.length; i++) {
                                if (obj.id == userFieldDataRelations[i].id) {
                                    userFieldDataRelations.splice(i, 1);
                                }
                            }
                        }
                    }
                    this.field.options.ext2 = JSON.stringify(curExt);
                }
                this.renderValue();
            },
            changeUserField (obj) {
                let curUser = this.userFieldList.find(item => item.id === obj.userFieldId);
                obj.userFieldObj = {id: curUser.id, name: curUser.name, type: curUser.type};
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.id === this.field.id) {
                        this.fieldsList[i].options.userFieldDataRelation = cloneDeep(this.field.options.userFieldDataRelation);
                    }
                }
                // this.renderValue(this.field);
                // this.modelData.fieldsList = this.fieldsList;
                // console.log(this.modelData);
                this.changeUserRefData(this.field);
            },
            changeLinkeField (obj) {
                for (let i = 0; i < this.linkPropField.length; i++) {
                    let cur = this.linkPropField[i];
                    if (cur.id === obj.linkPropFieldId) {
                        obj.linkPropFieldObj = cur;
                        obj.type = cur.type;
                        if (cur.type === 'subform') {
                            this.changeSubFormLinkeField(cur);
                        }
                    }
                }
                this.modelData.fieldsList = this.fieldsList;
            },
            changeLinkeFieldValue () {
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.id === this.field.id) {
                        this.fieldsList[i].options.limitFieldDataArray = cloneDeep(this.field.options.limitFieldDataArray);
                    }
                }
                this.modelData.fieldsList = this.fieldsList;
            },
            changeFormField (obj) {
                let curForm = this.formLevelFieldList.find(item => item.id === obj.formFieldId);
                obj.formFieldObj = {id: curForm.id, name: curForm.name, type: curForm.type};
                if (curForm.sonType) { // 子表单
                    for (let i = 0; i < this.fieldsList.length; i++) {
                        let field = this.fieldsList[i];
                        if (field.type === 'subform') {
                            let sonFieldList = field.options.fieldList;
                            for (let j = 0; j < sonFieldList.length; j++) {
                                let sonField = sonFieldList[j];
                                if (sonField.id === this.field.id) {
                                    sonField.options.userFieldDataRelation = this.field.options.userFieldDataRelation;
                                    sonField.options.setDataRelation = this.field.options.setDataRelation;
                                    break;
                                }
                            }
                        }
                    }
                }
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.id === this.field.id) {
                        this.fieldsList[i].options.userFieldDataRelation = cloneDeep(this.field.options.userFieldDataRelation);
                    }
                }
                // this.modelData.fieldsList = this.fieldsList;
                this.changeUserRefData(this.field);
            },
            initFormLevelFieldList () {
                let subformArry = [];
                let formArry = [];
                let flag = false;
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.type === 'subform') {
                        subformArry.push(cur);
                    } else {
                        if (cur.type !== 'link' || cur.type !== 'user') {
                            formArry.push(cur);
                        }
                        if (cur.id === this.field.id) {
                            flag = true;
                        }
                    }
                }
                if (flag) { // 点击的是主表单字段
                    this.formLevelFieldList = formArry;
                } else { // 点击的是子表单字段
                    let sonFieldArry = [];
                    for (let j = 0; j < subformArry.length; j++) {
                        let cur = subformArry[j].options.fieldList;
                        for (let x = 0; x < cur.length; x++) {
                            let cu = cur[x];
                            if (cu.id === this.field.id) {
                                sonFieldArry = cur;
                                break;
                            }
                        }
                    }
                    this.formLevelFieldList = [];
                    for (let y = 0; y < sonFieldArry.length; y++) {
                        let c = sonFieldArry[y];
                        if (c.type !== 'link' || c.type !== 'user') {
                            c.sonType = true;
                            this.formLevelFieldList.push(c);
                        }
                    }
                }
            },
            changeSerialNumberType (selected) {
                // console.log(selected);
            },
            handleSaveSerialNumberRelation () {
                this.initSerialNumberRelation();
                this.targetLink = [];
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let currobj = this.fieldsList[i];
                    if (currobj.type === 'link') {
                        this.targetLink.push(currobj);
                    }
                }
                if (this.serialNumberRefId) {
                    this.changeSerialNumberRelationForm(this.serialNumberRefId);
                }
                this.isShowSerialNumberRelation = true;
            },
            saveSelectedSerialNumberRelation () {
                this.isShowSerialNumberRelation = false;
                let serialNumberRelation = {serialNumberRefId: this.serialNumberRefId, serialNumberRelationFormId: this.serialNumberRelationFormId, serialNumberRelationFieldId: this.serialNumberRelationFieldId};
                this.field.ext1 = JSON.stringify(serialNumberRelation);
            },
            initSerialNumberRelation () {
                this.serialNumberRefId = '';
                this.serialNumberRelationFormId = '';
                this.serialNumberRelationFieldId = '';
                if (this.field.ext1) {
                    let serialNumberRelation = JSON.parse(this.field.ext1);
                    this.serialNumberRefId = serialNumberRelation.serialNumberRefId;
                    this.serialNumberRelationFormId = serialNumberRelation.serialNumberRelationFormId;
                    this.serialNumberRelationFieldId = serialNumberRelation.serialNumberRelationFieldId;
                } else {
                    this.field.ext1 = {};
                }
            },
            changeSerialNumberRelationForm (selected) {
                this.serialNumberRefId = selected;
                for (let i = 0; i < this.targetLink.length; i++) {
                    let cur = this.targetLink[i];
                    if (cur.id === selected) {
                        this.initField(cur.options.config.form.formId);
                    }
                }
            },
            changeSerialNumberRelationField (selected) {
                this.serialNumberRelationFieldId = selected;
            },
            async initField (formId) {
                this.serialNumberRelationFormId = formId;
                var param = { formId: formId, BIDimension: 0 };
                let field = await getBIFormConfigs(param);
                this.targetOptions = [];
                for (let j = 0; j < field.allList.length; j++) {
                    let obj = field.allList[j];
                    if (obj.type === 'serialNumber') {
                        this.targetOptions.push(obj);
                    }
                }
            },
            limitData (obj) {
                if (obj) {
                    this.initLimitData();
                } else {
                    this.linkPropField = [];
                }
            },
            initLimitData (fieldList) {
                if (this.$refs.linkPropConfig) {
                    let field = [];
                    if (fieldList) {
                        field = fieldList;
                    } else {
                        field = this.$refs.linkPropConfig.getLinkPropConfig();
                    }
                    let fieldArray = [];
                    if (field && field.length > 0) {
                        for (let i = 0; i < field.length; i++) {
                            let cur = field[i];
                            if (cur.type === 'select' || (cur.type === 'category' && cur.options.config.type === 'single')) {
                                fieldArray.push(cur);
                            }
                            if (cur.type === 'subform') {
                                fieldArray.push(cur);
                                if (this.field.options.limitFieldDataArray) {
                                    for (let i = 0; i < this.field.options.limitFieldDataArray.length; i++) {
                                        let subField = this.field.options.limitFieldDataArray[i];
                                        if (subField.linkPropFieldId === cur.id) {
                                            this.changeSubFormLinkeField(cur);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.linkPropField = fieldArray;
                    this.renderTimer = new Date().getTime();
                }
            },
            changeSubFormLinkeField (obj) {
                let subFormFieldIdListAll = [];
                obj.options.fieldList.forEach(subfield => {
                    subFormFieldIdListAll.push(subfield);
                });
                this.linkSubformPropField = subFormFieldIdListAll;
                this.renderTimer = new Date().getTime();
            },
            changeSeriaNumberGenerateField (id) {
                let res = this.fieldsList.find(obj => obj.id === id);
                let options = res.options.config.options;
                this.field.options.seriaNumberGenerateFieldOptions = options;
            },
            changeSynchronousApprovalComments () {
                let o = cloneDeep(approvalInfoDefault);
                for (let i = 0; i < o.length; i++) {
                    let cur = o[i];
                    cur.id = getUUID(16, 16);
                    cur.formField = cur.type + '_' + cur.id;
                }
                this.field.options.fieldList = o;
                this.modelData.fieldsList = cloneDeep(this.fieldsList);
            },
            changeAutomaticRecodeRefField () {
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.id === this.field.id) {
                        this.fieldsList[i].options.automaticRecodeFields = cloneDeep(this.field.options.automaticRecodeFields);
                        this.fieldsList[i].options.automaticRecodeRefField = cloneDeep(this.field.options.automaticRecodeRefField);
                    }
                }
                this.modelData.fieldsList = cloneDeep(this.fieldsList);
            },
            renderFieldList () {
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.id === this.field.id) {
                        this.fieldsList[i].options.masterUserDeptField = cloneDeep(this.field.options.masterUserDeptField);
                        if (cur.type === 'text') {
                            this.fieldsList[i].options.cascadeShowField = cloneDeep(this.field.options.cascadeShowField);
                        }
                        if (cur.type === 'subform') {
                            this.fieldsList[i].options.isLimitNumData = cloneDeep(this.field.options.isLimitNumData);
                            this.fieldsList[i].options.limitNums = cloneDeep(this.field.options.limitNums);
                        }
                        if (cur.type === 'date') {
                            this.fieldsList[i].options.syncApproveTime = cloneDeep(this.field.options.syncApproveTime);
                            this.fieldsList[i].options.syncTaskTime = cloneDeep(this.field.options.syncTaskTime);
                            this.fieldsList[i].options.syncCreateDataTime = cloneDeep(this.field.options.syncCreateDataTime);
                            this.fieldsList[i].options.isDynamicAssignmentDate = cloneDeep(this.field.options.isDynamicAssignmentDate);
                            this.fieldsList[i].options.dynamicAssignmentDateSourceFieldId = cloneDeep(this.field.options.dynamicAssignmentDateSourceFieldId);
                            this.fieldsList[i].options.dynamicAssignmentDateDay = cloneDeep(this.field.options.dynamicAssignmentDateDay);
                        }
                        if (cur.type === 'dictionary') {
                            this.fieldsList[i].options.dictionaryTreeChooseSonNode = cloneDeep(this.field.options.dictionaryTreeChooseSonNode);
                            this.fieldsList[i].options.dictionaryTreeChooseParentNode = cloneDeep(this.field.options.dictionaryTreeChooseParentNode);
                        }
                        if (cur.type === 'businessTree') {
                            this.fieldsList[i].options.businessTreeChooseSonNode = cloneDeep(this.field.options.businessTreeChooseSonNode);
                            this.fieldsList[i].options.businessTreeChooseParentNode = cloneDeep(this.field.options.businessTreeChooseParentNode);
                        }
                    }
                }
                this.modelData.fieldsList = cloneDeep(this.fieldsList);
                this.$emit('renderFieldList', this.fieldsList);
            },
            changeUserRefData () {
                let cacheField = cloneDeep(this.field);
                this.$emit('renderModelData', cacheField);
            },
            changeSelectTableHeaderFields (cacheField) {
                this.$emit('changeSelectTableHeaderFields', cacheField);
            },
            addSerialNumber () {
                let seriaNumberArray = [];
                let item = {};
                item.id = this.generateUUID();
                item.selectedNode = {id: '', label: ''};
                item.isShowSeriaSelectFieldConfig = false;
                item.seriaNumberSelectTypeFormFieldId = '';
                item.isShowSeriaConfig = false;
                item.isShowSeriaSelectFieldConfig = false;
                item.isShowSeriaBusinessTypeConfig = false;
                item.isShowSeriaDepartTypeConfig = false;
                if (this.field.options.serialNumberRuleList) {
                    seriaNumberArray = this.field.options.serialNumberRuleList;
                }
                seriaNumberArray.push(item);
                this.field.options.serialNumberRuleList = seriaNumberArray;
                this.renderFieldList();
            },
            handleSerialNumber (data, node, tree) {
                let callBackData = data.callBackData;
                this.field.options.serialNumberRuleList.forEach(element => {
                    if (callBackData.id === element.id) {
                        if (data.center && data.center.indexOf('$department') !== -1) {
                            element.isShowSeriaConfig = true;
                        } else {
                            element.isShowSeriaConfig = false;
                        }
                        if (data.center && data.center.indexOf('$selectField') !== -1) {
                            element.isShowSeriaSelectFieldConfig = true;
                        } else {
                            element.isShowSeriaSelectFieldConfig = false;
                        }
                        if ((data.suffix && data.suffix.indexOf('$businessType') !== -1) ||
                         (data.prefix && data.prefix.indexOf('$businessType') !== -1) ||
                         (data.center && data.center.indexOf('$businessType') !== -1)) {
                            element.isShowSeriaBusinessTypeConfig = true;
                        } else {
                            element.isShowSeriaBusinessTypeConfig = false;
                        }
                        if ((data.suffix && data.suffix.indexOf('$departType') !== -1) ||
                         (data.prefix && data.prefix.indexOf('$departType') !== -1) ||
                         (data.center && data.center.indexOf('$departType') !== -1)) {
                            element.isShowSeriaDepartTypeConfig = true;
                        } else {
                            element.isShowSeriaDepartTypeConfig = false;
                        }
                        element.selectedNode.id = data.id;
                        element.selectedNode.label = data.label;
                        this.renderFieldList();
                    }
                });
            },
            buildTakeEffectFieldOptions (item) {
                let takeEffectField = item.takeEffectField;
                let fieldOpt = this.formLevelFieldList.find(element => element.id === takeEffectField);
                item.takeEffectFieldOptions = fieldOpt.options.config.options;
                this.renderFieldList();
            },
            renderSerialNumberVal () {
                if (this.field.options.moreSerialNumber) { // 多规则移除原先单规则的配置
                    this.field.options.config.options = [];
                    this.field.options.defaultValue = '';
                }
                this.renderFieldList();
            },
            deleteSeriRul (item, index) {
                item.splice(index, 1);
            }
        }
    };
</script>

<style lang="less">
    .field-props {
        .el-form-item{
            .el-form-item__content{
                .location-pops{
                    .locationCenter-item{
                        display: flex;
                        cursor: pointer;
                        margin-top: 10px;
                        .locationCenter-item-lable{
                            flex: 1;
                            display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
                            -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
                            overflow: hidden; /*超出的文本隐藏*/
                            text-overflow: ellipsis; /* 溢出用省略号*/
                            -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
                        }
                        .locationCenter-item-oprea{
                            width: 30px;
                            text-align: center;
                        }
                    }
                }
                .relation-data-set{
                    .relation-data-set-content-item{
                        width: 95%;
                        padding: 5px;
                        border: solid 1px #d8d7da;
                        margin-top: 6px;
                        .option-btn{
                            margin-top: 6px;
                            width: 98%;
                            .el-button{
                                width: 80%;
                                text-align: center;
                                border: 1px solid #c00007;
                                color: #b86e4f;
                            }
                        }
                        .option-data{
                           .option-data-field,.field-data-field{
                               margin-top: 6px;
                               .el-tooltip{
                                   border:none;
                                   background:none;
                                   cursor: pointer;
                               }
                           }
                        }
                    }
                    .option-data-add{
                        margin-top: 10px;
                        width: 98%;
                        text-align: center;
                        .el-button{
                            width: 100%;
                            text-align: center;
                        }
                    }
                }
                .show-data-filter{
                    .limit-data-set-content{
                        width: 100%;
                        .limit-data-set-content-item{
                            width: 95%;
                            padding: 5px;
                            border: solid 1px #d8d7da;
                            margin-top: 6px;
                            .option-btn{
                                margin-top: 6px;
                                width: 98%;
                                .el-button{
                                    width: 82%;
                                    text-align: center;
                                    border: 1px solid #c00007;
                                    color: #b86e4f;
                                }
                            }
                            .option-data{
                                .option-data-field{
                                    margin-top: 6px;
                                }
                            }
                        }
                    }
                    .option-data-add{
                        margin-top: 10px;
                        width: 98%;
                        text-align: center;
                        .el-button{
                            width: 100%;
                            text-align: center;
                        }
                    }
                }
            }
        }
        .el-radio-group {
            margin-top: 10px;
        }

        .el-form-item__label {
            padding: 0;
        }
        .num-content-item{
            height: 35px;
            line-height: 35px;
            display: flex;
            .left{
                flex: 9;
            }
            .right{
                flex: 1;
            }
        }
        .serialNumberBox{
            .serialNumberBoxItem{
                margin-top: 10px;
                .serialNumberBoxItemLabel{
                    background: #f2f2f2;
                    height: 30px;
                    line-height: 30px;
                    text-indent: 10px;
                }
                .serialNumberBoxItemTree{
                    margin-top: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FieldProps/FieldProps.vue